import * as React from "react";
import "../../../../assets/scss/components/toc/orderBook/generic/obAssetDetailPopup.scss";
import "../../../../assets/scss/components/toc/orderBook/obDetails/obDetails.scss";

export interface IObAssetDetailPopupProps {}

const ObAssetDetailPopup: React.FC<IObAssetDetailPopupProps> = (props) => {
	return <div className="Asset_detail_Ppup">{props.children}</div>;
};

export default ObAssetDetailPopup;
